import { render, staticRenderFns } from "./create-update-dialog.vue.js?vue&type=template&id=202c9c06&scoped=true!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./create-update-dialog.vue?vue&type=template&id=202c9c06&scoped=true"
import script from "./create-update-dialog.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./create-update-dialog.vue?vue&type=script&lang=js"
export * from "./create-update-dialog.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./create-update-dialog.vue?vue&type=script&lang=js"
import style0 from "./create-update-dialog.vue.scss?vue&type=style&index=0&id=202c9c06&lang=scss&scoped=true!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./create-update-dialog.vue?vue&type=style&index=0&id=202c9c06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202c9c06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202c9c06')) {
      api.createRecord('202c9c06', component.options)
    } else {
      api.reload('202c9c06', component.options)
    }
    module.hot.accept("./create-update-dialog.vue.js?vue&type=template&id=202c9c06&scoped=true!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./create-update-dialog.vue?vue&type=template&id=202c9c06&scoped=true", function () {
      api.rerender('202c9c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIHelper/components/ChatFrame/ChatExtract/detail/components/create-update-dialog.vue"
export default component.exports